import type { CcmsSuspension } from "@/types";

type PersonSuspensionFields = {
  openCcmsSuspensions?: CcmsSuspension[] | null;
  ccmsSuspensions?: CcmsSuspension[] | null;
};

/** Open CCMS rows for status chrome (`viewPersonMembership`). Falls back to legacy `ccmsSuspensions`. */
export function ccmsSuspensionsForStatus(person: PersonSuspensionFields): CcmsSuspension[] | undefined {
  if (person.openCcmsSuspensions !== undefined && person.openCcmsSuspensions !== null) {
    return person.openCcmsSuspensions;
  }

  return person.ccmsSuspensions ?? undefined;
}

export function hasMembershipSuspensionChromeLoaded(
  person: PersonSuspensionFields & { latestProgram?: unknown }
): boolean {
  return Boolean(
    person.latestProgram && (person.openCcmsSuspensions !== undefined || person.ccmsSuspensions !== undefined)
  );
}
